import React from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ButtonLoadingProps {
  isLoading: boolean;
  loadingText?: React.ReactNode;
  loadingIcon?: React.ReactNode;
}

type Props = ButtonLoadingProps & ButtonProps;

const defaultProps: Partial<Props> = {
  loadingIcon: <CircularProgress size={14} disableShrink />,
};
export function ButtonLoading(props: Props) {
  const { t } = useTranslation();
  const { isLoading, loadingText = t("label.loading"), loadingIcon, children, ...restProps } = props;

  return (
    <Button
      disabled={isLoading || restProps.disabled}
      color="primary"
      variant="contained"
      type="submit"
      size="medium"
      startIcon={isLoading && loadingIcon}
      {...restProps}
    >
      {!isLoading && children}
      {isLoading && loadingText}
    </Button>
  );
}

ButtonLoading.defaultProps = defaultProps;
